import React from 'react';

import './style.css';

export default class Flyout extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    if (event.defaultPrevented) return;

    if (this.props.onClose) {
      this.props.onClose(event);
      event.preventDefault();
    }
  }

  render() {
    var flyoutClass = 'flyout-contents';
    if (this.props.className) {
      flyoutClass += ' ' + this.props.className;
    }
    return (
      <div className="flyout-component">
        <div className="flyout-mask" onClick={this.onClick}></div>
        <div className={flyoutClass}>{this.props.children}</div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Flyout/index.js
 **/